import React, { useState, useEffect } from "react";
import "./PrimaryIncome.css";
import axios from "axios";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { url } from "../../../../../../../../../../App";

function PrimaryIncome({ totalIncome, loanID, incomeMargin, isDisbursed }) {
    const [margin, setMargin] = useState(""); 
    const token = Cookies.get("Token");
    const email = Cookies.get("Email");

    useEffect(() => {
        if (incomeMargin) {
            setMargin(incomeMargin);
        }
    }, [incomeMargin]);

    const sanitizedMargin = Number(margin) || 0; 
    const finalIncome = (sanitizedMargin/100) * totalIncome;
    const handleSetMargin = async (e) => {
        const newMargin = e.target.value;

      
        if (newMargin < 0 || newMargin > 100) {
            toast.error("Margin must be between 0 and 100.");
            return;
        }

        setMargin(newMargin); 

        try {
            const response = await axios.post(`${url}/cam/change/margin`, {
                token,
                email,
                margin: newMargin,
                loanId: loanID,
            });
            toast.success("Margin updated successfully!"); // Notify success
            console.log("Margin updated:", response.data);
        } catch (error) {
            console.error("Error updating margin:", error);
            toast.error("Failed to update margin. Please try again."); // Notify error
        }
    };

    return (
        <div style={{ backgroundColor: "rgb(226, 240, 217)", width: "50%", margin: "auto" }}>
            <ToastContainer /> {/* Required for toast notifications */}
            <table style={{ border: "1px solid black", width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                    <tr>
                        <td style={{ border: "1px solid black", padding: "5px" }}>
                            <b>Total Income</b>
                        </td>
                        <td style={{ border: "1px solid black", padding: "5px" }}>
                            {totalIncome}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ border: "1px solid black", padding: "5px" }}>
                            <b>Margin (%)</b>
                        </td>
                        <td style={{ border: "1px solid black", padding: "5px" }}>
                            <input
                                type="number"
                                min="0"
                                max="100" // Logical upper limit
                                step="0.1"
                                value={margin}
                                onChange={handleSetMargin}
                                disabled={isDisbursed}
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ border: "1px solid black", padding: "5px" }}>
                            <b>Final Income</b>
                        </td>
                        <td style={{ border: "1px solid black", padding: "5px" }}>
                            {finalIncome.toFixed(2)}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default PrimaryIncome;
